import type { Theme } from '@mui/material';
import { paperClasses } from '@mui/material';

// import type { Components } from '@mui/material/styles';
import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import { RootContainers } from '@/modules/common/helpers';

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-0';

export default function MUIPopover(theme: Theme) /* : Components['MuiPopover'] */ {
  return {
    defaultProps: {
      container: RootContainers.getMUIPortalContainer(),
      disableScrollLock: true,
      elevation: 15,
    },
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          [`.${paperClasses.root}`]: {
            borderRadius: 0,
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          [`.${paperClasses.root}`]: {
            borderRadius: theme.shape.borderRadiusCircular,
          },
        },
      },
    ],
    styleOverrides: {
      root: {
        marginTop: theme.spacing(0),
      },
    },
    // variants: [],
  };
}
